import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.skies = JSON.parse(this.data.get("skies") || "{}")
    const selected = this.element.querySelector("input[name='check_in[mood]']:checked")
    if (selected) this.applyMood(selected.value)
  }

  change(event) {
    this.applyMood(event.target.value)
  }

  applyMood(value) {
    const sky = this.skies[value]
    if (!sky) return

    this.element.style.setProperty("--climate-sky-from", sky.from)
    this.element.style.setProperty("--climate-sky-to", sky.to)
  }
}
